// OIDC Client
import { UserManager } from 'oidc-client'

// Config
import { config } from './config.oidc'

/**
 * @description Instance of OIDC user managmenr
 *
 * @param {boolean} isSilent
 *
 * @return {UserManager} UserManager
 */
const oidc_userManager = (isSilent: boolean = false): UserManager => new UserManager(config(isSilent))

export { oidc_userManager }
